import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomStockProtectionOverviewComponent } from './components/custom-stock-protection/custom-stock-protection-overview.component';
import { IconModule, LayoutConfig, SpinnerModule } from '@spartacus/storefront';
import { AuthGuard, CmsConfig, ConfigModule, I18nConfig, I18nModule, provideConfig, provideDefaultConfig, UrlModule } from '@spartacus/core';
import { OccConfig } from '@spartacus/core';
import { CustomStockProtectionAdapter } from './custom-stock-protection.adapter';
import { StoreModule } from '@ngrx/store';
import { customStockProtectionFeatureKey, customStockProtectionReducer } from './store/custom-stock-protection.reducer';
import { CustomStockProtectionEffects } from './store/custom-stock-protection.effects';
import { EffectsModule } from '@ngrx/effects';
import { CustomStockProtectionInstructionsComponent } from './components/custom-stock-protection-instructions/custom-stock-protection-instructions.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { RouterModule } from '@angular/router';
import { CustomStockProtectionDetailsComponent } from './components/custom-stock-protection-details/custom-stock-protection-details.component';
import { UigCustomStockProtectionGuard } from './uig-custom-stock-protection.guard';


@NgModule({
  declarations: [CustomStockProtectionOverviewComponent, CustomStockProtectionInstructionsComponent, CustomStockProtectionDetailsComponent],
  imports: [
    CommonModule,
    I18nModule,
    SpinnerModule,
    FormsModule,
    NgSelectModule,
    RouterModule,
    UrlModule,
    IconModule,
    ConfigModule.withConfig({
      backend: {
        occ: {
          endpoints: {
            customStockProtectionOverview: '/myrio/stockprotection',
            customSearchStockProtection: '/myrio/stockprotection/search',
            customStockProtectionDetails: '/myrio/stockprotection/${processNumber}',
            customUpdatSerialNumbers: '/myrio/stockprotection/${processNumber}/update',
            customSerialNumbersUpload: '/myrio/stockprotection/upload'
          },
        },
      },
    } as OccConfig),
    StoreModule.forFeature(
      customStockProtectionFeatureKey,
      customStockProtectionReducer
    ),
    EffectsModule.forFeature([CustomStockProtectionEffects])
  ],
  providers: [
    provideConfig(<CmsConfig | LayoutConfig>{
      cmsComponents: {
        StockProtectionComponent: {
          component: CustomStockProtectionOverviewComponent,
          guards :[AuthGuard , UigCustomStockProtectionGuard]
        }
      }
    }),
    {
      provide: CustomStockProtectionAdapter,
      useClass: CustomStockProtectionAdapter,
    },
  ],
})
export class CustomStockProtectionModule { }
